import useUser from 'hooks/useUser';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as styles from './styles/styles.module.scss';
import PaymentMethodName from 'types/PaymentMethodName';
import PaymentMethod from 'types/PaymentMethod';

type Props = {
  tabs: PaymentMethod[];
  activeTab: number;
  handler: (index: number) => {};
  showPayWithCard?: boolean;
};

const LinkItem = ({ item, showPayWithCard }: { item: PaymentMethod; showPayWithCard: boolean }) => {
  const user = useUser();

  const { name, iconPath } = item;

  switch (name) {
    case PaymentMethodName.PayPal:
    case PaymentMethodName.ApplePay:
    case PaymentMethodName.AmazonPay:
      return (
        <span className={styles.tabIcon}>
          <img alt={name} src={iconPath} />
        </span>
      );
    case PaymentMethodName.PayByCreditCard:
      return user?.isPromoEligible && !showPayWithCard ? (
        <FormattedMessage defaultMessage="Enter payment details" />
      ) : (
        <FormattedMessage defaultMessage="Pay with card" />
      );
  }
};

const PaymentTabs = ({ tabs, handler, activeTab, showPayWithCard = false }: Props) => {
  const grouped = {} as { [key: string]: JSX.Element[] };
  let tabKey = -1;

  tabs.map(tab => {
    if (!tab.showTab) {
      return;
    }

    tabKey = tab.tab || tabKey + 1;

    if (!grouped[tabKey]) {
      grouped[tabKey] = [];
    }

    return grouped[tabKey].push(<LinkItem key={tab.name} item={tab} showPayWithCard={showPayWithCard} />);
  });

  return (
    <div className={styles.tabBar}>
      {Object.keys(grouped).map((item, index) => {
        return (
          <div
            key={index}
            tabIndex={0}
            role="tab"
            className={`${styles.tab} ${index == activeTab ? styles.active : ''}`}
            onClick={() => handler(index)}
            onKeyDown={() => handler(index)}
          >
            {grouped[item]}
          </div>
        );
      })}
    </div>
  );
};

PaymentTabs.defaultProps = {
  handler: () => {},
  activeTab: 0
};

export default PaymentTabs;
